import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { UserService } from '@app-services/user/user.service';
import { TenantConstant } from '@app-constants/tenant.constant';
import { openTSDialog } from 'src/app/helpers/methods';
import {  openDefaultLoginDialog, openTermsAndConditionsDialog, signup, socialMediaClicked } from '@app-core/components/home/home.component';
import { SignupService } from '@app-services/signup/signup.service';
import { SubscriptionService } from '@app-services/subscription/subscription.service';

@Component({
  selector: 'app-test-series',
  templateUrl: './test-series.component.html',
  styleUrls: ['./test-series.component.css']
})
export class TestSeriesComponent implements OnInit {
  @ViewChild('content') public content: any;
  signup = signup;
  openDefaultLoginDialog = openDefaultLoginDialog;
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  openTSDialog = openTSDialog;
  mobileNumberForm: FormGroup;
  mobileNumberValid = false;
  tenant: any = TenantConstant.tenant;
  constructor(
    public modalservice: NgbModal,
    private fb: FormBuilder,
    public userService: UserService,
    public signUpService: SignupService, private dialog: MatDialog, private gaService: GAnalyticsService, public subscriptionservice : SubscriptionService) { }

  ngOnInit(): void {
    this.mobileNumberForm = this.fb.group({
      mobilenumber: ['', [Validators.required, Validators.pattern(/^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[6789]\d{9}|(\d[ -]?){10}\d$/)]]
    })
  }

  openSignUpDialog(): void {
    this.openTSDialog({
      message: 'One more step and you are all set',
      source: 'Testseries',
      phone: this.mobileNumberForm.value.mobilenumber,
      countryCode: '+91',
    })
  }
  onInputChange() {

    let Value = this.mobileNumberForm.value.mobileNumber;
    let stringLength = String(Value).length;
    if (Value && stringLength > 10) {
      let newValue = parseInt(String(Value).slice(0, 9));
      this.mobileNumberForm.value.mobileNumber = newValue;
    }

    if (stringLength > 8 && this.mobileNumberForm.valid) {
      this.mobileNumberValid = true;
    } else {
      this.mobileNumberValid = false;
    }
  }

  ngOnDestroy(){
  }
}
